import { useDrawerInstance, useSwipeableViews } from '@cast/design-system';

import { EdgeLocationDetailsForm } from '../../_components/EdgeLocationDetailsForm';
import { EdgeLocationFormValues, EdgeLocationInitialData } from '../../types';

type CreateEdgeLocationStepProps = {
  initialData?: EdgeLocationInitialData;
  isActive?: boolean;
  onConfigureComplete: (formValues: EdgeLocationFormValues) => void;
};

export const CreateEdgeLocationStep = ({
  initialData,
  isActive = true,
  onConfigureComplete,
}: CreateEdgeLocationStepProps) => {
  const { close, setOnCloseGuard } = useDrawerInstance();
  const ctx = useSwipeableViews();

  return (
    <EdgeLocationDetailsForm
      mode="create"
      initialData={initialData}
      guardOnClose={isActive}
      onClose={() => close()}
      onSubmit={(formValues) => {
        onConfigureComplete(formValues);
        setOnCloseGuard(false);
        ctx?.goToNextSlide();
      }}
    />
  );
};
